import { Typography } from "@mui/material";
import { formatRelativeTime } from "./formatRelativeTime";
import t from "./translations";
import useNow from "./useNow";

export default function UpdatedAt({ lastLoadedAt }: { lastLoadedAt: Date }) {
  const now = useNow();
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      data-testid="lidar-upload-status.updated-at"
    >
      {t.UpdatedAt(formatRelativeTime(lastLoadedAt, now))}
    </Typography>
  );
}
